<template>
  <div class="base">
    <div class="top-head">
      <inside-header title="订单详情" color="white" />
      <div style="padding: 0 15px;">
        <div class="order-info">
          <div class="order-status-process">
            <span class="status-lable" style="color: ">{{ order_info.status | statusFilter }}</span>
            <!-- <span class="time" :style="{ color: statusColor }">剩余7次课</span> -->
          </div>
          <div class="student">
            <div class="student-info">
              <span class="name">{{ student_info.nick_name }}</span>
              <span class="grade">{{ student_info.stage }}</span>
            </div>
            <div class="mobile-area">
              <span class="icon">
                <a-icon style="color: #ff5c00" type="phone" />
              </span>
              <span class="mobile">{{ user_info.phone }}</span>
            </div>
            <div class="local-area">
              <span class="icon">
                <van-icon color="#ff5c00" name="location-o" />
              </span>
              <span class="local">{{ user_info.address }}</span>
            </div>
          </div>
          <div class="lecture-details">
            <div class="title">
              {{ order_info.teaching_subject }}-{{ service_pack.title }}
            </div>
            <a-row class="package-info">
              <a-col :span="18" class="list">
                <div class="item">
                  <span class="label-title">授课时间</span>
                  <span class="content">{{ order_info.data_info_str }}</span>
                </div>
                <div class="item">
                  <span class="label-title">授课周期</span>
                  <span class="content">{{ order_info.cycle }}周</span>
                </div>
                <div class="item">
                  <span class="label-title">下次授课</span>
                  <span class="content">{{ last_teaching_time }}</span>
                  <span v-if="last_teaching_str" class="week">（{{ last_teaching_str }}）</span>
                  <span v-else class="week">无</span>
                </div>
              </a-col>
              <a-col :span="6" class="amount">
                <div class="totol">
                  <span class="prefix">￥</span>
                  <span class="money">{{ order_info.subtotal }}</span>
                </div>
                <div class="price">
                  <span class="prefix">￥</span>
                  <span class="money">{{ service_pack.price }}/小时</span>
                </div>
              </a-col>
            </a-row>
          </div>
        </div>
      </div>
    </div>
    <!-- 时间安排 -->
    <div class="order-time-arrange">
      <!-- 时间安排 -->
      <div class="schedule">
        <div class="lable-desc">
          具体时间安排
        </div>
        <div class="date-arr">
          <span v-for="(schedule_item, index) in schedule" :key="index"
            :class="{ item: true, complete: schedule_item.past_times }">{{ schedule_item.date }}({{ schedule_item.str
            }})</span>
        </div>
      </div>
      <!-- 订单号 -->
      <div class="order-area">
        <div class="order">
          订单号：{{ order_info.ordernum }}
        </div>
        <div class="create_time">
          创建时间：{{ order_info.create_time | timeFormat }}
        </div>
      </div>
    </div>
    <!-- 支付,末尾 -->
    <div class="pay-area">
      <div class="right">
        <a-button class="cancel-btn">
          联系家长
        </a-button>
        <a-button v-if="order_info.status === 'Pending' || order_info.status === 'Active'" type="primary"
          class="pay-btn" @click="goOrderCancel(order_info.ordernum)">
          取消订单
        </a-button>
      </div>
    </div>
    <!--  -->
  </div>
</template>
<script>
import { InsideHeader } from '@/components'

const statusMap = {
  Pending: {
    status: 'warning',
    text: '等待中'
  },
  Active: {
    status: 'success',
    text: '已激活'
  },
  Cancelled: {
    status: 'default',
    text: '已取消'
  },
  Cancelling: {
    status: 'default',
    text: '取消中'
  },
  Fraud: {
    status: 'error',
    text: '有欺诈'
  },
  Complete: {
    status: 'success',
    text: '已完成'
  }
}
export default {
  name: 'TeacherOrderDetails',
  components: {
    InsideHeader
  },
  filters: {
    statusFilter(type) {
      for (var key in statusMap) {
        if (key === type) {
          var text = statusMap[key].text
          break
        }
      }
      return text
    },
    statusTypeFilter(type) {
      for (var key in statusMap) {
        if (key === type) {
          var status = statusMap[key].status
          break
        }
      }
      return status
    }
  },
  props: {
    ordernum: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      statusColor: '#ff5c00',
      loading: true,
      state: {
        orderCancel: false
      },
      order_id: '',
      queryData: {},
      order_info: [],
      teacher_info: [],
      service_pack: {},
      // 用户信息
      user_info: {},
      // 教员信息
      student_info: [],
      // 服务包信息
      pack_info: [],
      orderItem: [],
      amount: 0,
      columns: [
        {
          title: '时间',
          dataIndex: 'date'
        },
        {
          title: '时长',
          dataIndex: 'hour'
        },
        {
          title: '描述',
          dataIndex: 'desc'
        },
        {
          title: '地址',
          dataIndex: 'address'
        }
      ],
      service_status: 'not_started',
      // 可取消
      cancellable: false,
      orderStatus: '',
      payStatus: '',
      schedule: [],
      last_teaching_str: '',
      last_teaching_time: '',
      teaching_hour: 0
    }
  },
  watch: {
    order_info(val) {
      this.orderStatus = val.status
      this.orderItem = val.order_item
      this.amount = val.amount
      this.payStatus = val.pay_status

      if (val.status !== 'Complete' && val.status !== 'Cancelled' && val.status !== 'Cancelling') {
        this.cancellable = true
      }
    }
  },
  created() {
    this.loadData(this.ordernum)
  },
  methods: {
    loadData(ordernum) {
      this.loading = true
      this.$http({
        url: '/index/teacher/orderInfo',
        method: 'get',
        params: {
          ordernum: ordernum
        }
      }).then(res => {
        this.loading = false
        if (res.status === 'success') {
          console.log(res)
          const data = res.data
          this.order_info = data.order_info
          this.student_info = data.student_info
          this.teacher_info = data.teacher_info
          this.service_pack = data.service_pack
          this.schedule = data.schedule
          this.last_teaching_str = data.last_teaching_str
          this.last_teaching_time = data.last_teaching_time
          this.teaching_hour = data.teaching_hour
          this.user_info = data.user_info
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          })
        }
      })
    },
    goOrderCancel(orderNum) {
      this.$router.push({ name: 'TeacherOrderCancel', params: { ordernum: orderNum } })
    }
  }
}
</script>
<style lang="stylus">
  .base {
      min-width: 280px;
      max-width: 420px;
      margin: auto;
      background-color: #fff;
  }

  .top-head {
    width: 100%;
    // height: 300px; 高度自适应
    background: url('~@/assets/order/back@2x.png') no-repeat;
    // 背景图片自适应div
    background-size: contain

    .order-info {
      // height: 260px;
      background-color: #ffffff;
      border-radius: 10px;
      padding: 30px 15px;
      box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);

      .order-status-unpaid {
        overflow: hidden;

        .status-lable {
          font-family: PingFang-SC-Medium;
          font-size: 18px;
          color: #ff5c00;
          float: left;
        }

        .time {
          font-family: PingFang-SC-Medium;
          font-size: 12px;
          line-height: 24px;
          color: #ff5c00;
          float: right;
        }
      }

      .order-status-process {
        overflow: hidden;

        .status-lable {
          font-family: PingFang-SC-Medium;
          font-size: 18px;
          // line-height: 16px;
          color: #5bc979;
          float: left;
        }

        .time {
          font-family: PingFang-SC-Medium;
          font-size: 12px;
          line-height: 16px;
          color: #333333;
          float: right;
        }
      }

      .student {
        overflow: hidden;
        margin-top: 10px;
        padding: 8px 0;
        border-bottom: 1px solid #eee;

        .student-info {
          .name {
            font-family: PingFang-SC-Bold;
            font-size: 18px;
            line-height: 21px;
            color: #333333;
            font-weight: bold;
          }

          .grade {
            font-family: PingFang-SC-Medium;
            font-size: 14px;
            line-height: 28px;
            color: #666666;
            margin-left: 10px;
          }
        }

        .mobile-area {
            .icon {
              color: $theme-color;
            }

            .mobile {
              font-family: PingFang-SC-Medium;
              font-size: 14px;
              line-height: 28px;
              color: #666666;
              margin-left: 10px;
            }
          }

          .local-area {
            .icon {
              color: $theme-color;
            }

            .local {
              font-family: PingFang-SC-Medium;
              font-size: 14px;
              line-height: 28px;
              color: #666666;
              margin-left: 10px;
            }
          }
      }

      .lecture-details {
        padding: 10px 0;

        .title {
          font-family: PingFang-SC-Bold;
          font-size: 15px;
          line-height: 16px;
          color: #333333;
          font-weight: bold;
        }

        .package-info {
          margin-top: 10px;

          .list {
            .item {
              line-height: 21px;

              .label-title {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                line-height: 21px;
                color: #999;
              }

              .content {
                margin-left: 5px;
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                color: #666666;
              }

              .week {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                color: #ff5c00;
              }
            }
          }

          .amount {
            text-align: right;

            .totol {

              .prefix {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                line-height: 19px;
                color: #333333;
              }

              .money {
                font-family: PingFang-SC-Medium;
                font-size: 18px;
                color: #333333;
              }

            }

            .price {

              .prefix {
                font-family: PingFang-SC-Medium;
                font-size: 10px;
                line-height: 19px;
                color: #999;
              }

              .money {
                font-family: PingFang-SC-Medium;
                font-size: 12px;
                line-height: 19px;
                color: #999;
              }
            }
          }
        }
      }
    }
  }

  // 时间安排
  .order-time-arrange {
    padding: 15px;

    .schedule {
      padding: 15px;
      box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
      margin-top: 15px;

      .teacher-area {
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;

        .head-img {
          img {
            width: 30px;
            height: 30px;
          }
        }

        .identity {
          .name {
            font-family: PingFang-SC-Bold;
            font-size: 15px;
            line-height: 18px;
            color: #333333;
            font-weight: bold;
          }

          .desc {
            font-family: PingFang-SC-Medium;
            font-size: 12px;
            line-height: 16px;
            color: #999999;
          }
        }

        .duration {
          text-align: right;

          span {
            font-family: PingFang-SC-Medium;
            font-size: 12px;
            line-height: 16px;
            color: #333333;
          }
        }
      }
      // dd
      .lable-desc {
        font-family: PingFang-SC-Medium;
        font-size: 15px;
        line-height: 32px;
        color: #333333;
      }

      .date-arr {
        min-height: 60px;

        .item {
          font-family: PingFang-SC-Medium;
          font-size: 14px;
          line-height: 16px;
          color: #333333;
          margin-right: 15px;
        }

        .complete {
          font-family: PingFang-SC-Medium;
          font-size: 14px;
          line-height: 16px;
          color: #999999;
        }
      }
    }
  }

  .order-area {
    margin-top: 20px;

    font-family: PingFang-SC-Medium;
    font-size: 14px;
    line-height: 24px;
    color: #999999;
  }

  .pay-area {
    height: 56px;
    overflow: hidden;
    position: fixed;
    bottom: 0;
    width: 100%;
    padding: 10px 15px;
    box-shadow: 0 0 10px 0 rgba(216,216,216,0.3);
    background-color: #fff;

    .left {
      float: left;

      .label-text {
        font-family: PingFang-SC-Medium;
        font-size: 14px;
        line-height: 32px;
        color: #999999;
      }

      .prefix {
        font-family: PingFang-SC-Medium;
        font-size: 12px;
        line-height: 19px;
        color: #ff5c00;
      }

      .total {
        font-family: PingFang-SC-Medium;
        font-size: 21px;
        color: #ff5c00;
      }
    }

    .right {
      float: right

      .cancel-btn {
        width: 87px;
        height: 31px;
        border-radius: 15px;
        border: solid 1px #ececec;

        font-family: PingFang-SC-Medium;
        font-size: 14px;
        line-height: 14px;
        color: #999999;

        margin-right: 10px;
      }

      .pay-btn {
        height: 31px;
        background-color: #ff5c00;
        border-radius: 15px;
      }
    }

  }

</style>
